import React, { forwardRef } from "react";

import { Context } from "../context";
import { Props } from "./types";
import { ElementsOverlay } from "./elementsOverlay";
import { ConstraintsOverlay } from "./constraintsOverlay";
import styles from "./styles.scss";

const Graph = forwardRef(
  (
    { gantt, dates, projects, filter, sort, constraints }: Props,
    forwardedGraphRef: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { cell } = React.useContext(Context);

    return (
      <div ref={forwardedGraphRef} className={styles.graph}>
        <div
          ref={ref}
          className={styles.main}
          style={{ width: cell.width * dates.length }}
        >
          <ConstraintsOverlay
            graphRef={ref}
            width={cell.width * dates.length}
            dates={dates}
            constraints={constraints}
          >
            <ElementsOverlay
              graphRef={ref}
              projects={projects}
              filter={filter}
              sort={sort}
              dates={dates}
              gantt={gantt}
              constraints={constraints}
            />
          </ConstraintsOverlay>
        </div>
      </div>
    );
  },
);

export { Graph };
